import { render, staticRenderFns } from "./LH6gift.vue?vue&type=template&id=1f5b17cc&scoped=true&"
import script from "./LH6gift.vue?vue&type=script&lang=js&"
export * from "./LH6gift.vue?vue&type=script&lang=js&"
import style0 from "./LH6gift.vue?vue&type=style&index=0&id=1f5b17cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5b17cc",
  null
  
)

export default component.exports